import React, { useContext, useEffect, useState } from 'react'
import BookmarkContext from './context/BookmarkContext';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';

const Login = () => {
    const {
        email,
        setEmail,
        password,
        setPassword,
        APIKEY,
        toast,
        setLoading,
        fetchBookmark,
        handleClearComponent,
        loading,
        otp,
        setOtp
    } = useContext(BookmarkContext);

    const [toggleVerifyOtp, setToggleVerifyOtp] = useState(false);
    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const [countdown, setCountdown] = useState(0);

    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${APIKEY}/api/userAuth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password })
            });

            const data = await response.json();

            if (response.ok) {
                setLoading(false);
                toast.success(data.message);
                setToggleVerifyOtp(true);
                setOtp("");
            } else {
                toast.error(data.message);
                setLoading(false);
                setToggleVerifyOtp(false);
            }
        } catch (error) {
            toast.error("Error While Login");
            setLoading(false);
            setToggleVerifyOtp(false);
        }
    };

    const handleVerifyOtp = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${APIKEY}/api/userAuth/verifyOtpLogin`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, otp })
            })

            const data = await response.json();

            if (response.ok) {
                if (data.verified === true) {
                    localStorage.setItem('User', data.success);
                    localStorage.setItem('token', data.authToken);
                    localStorage.setItem('Verified', data.verified);
                    localStorage.setItem('Admin', data.admin);
                    await fetchBookmark();
                    navigate("/bookmark");
                    setLoading(false);
                    handleClearComponent();
                    toast.success(data.message);
                }
                else {
                    navigate("/verifyEmail");
                    setPassword("");
                    setOtp("");
                    setLoading(false);
                }

            } else {
                toast.error(data.message);
                setLoading(false);
                navigate('/login');
            }

        } catch (error) {
            toast.error("Error While Verifying OTP");
            setLoading(false);
        }
    }

    const handleResendOtp = async () => {
        try {
            setLoading(true);
            const msg = "Login into Bookmark Site"
            const response = await fetch(`${APIKEY}/api/userAuth/resendOtp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, msg })
            })

            const data = await response.json();

            if (response.ok) {
                toast.success(data.message);
                setLoading(false);
                // Disable the resend OTP button for 10 minutes
                setIsResendDisabled(true);
                setCountdown(600);  // 10 minutes in seconds

                // Start countdown
                const interval = setInterval(() => {
                    setCountdown((prevCountdown) => {
                        if (prevCountdown <= 1) {
                            clearInterval(interval);  // Stop the countdown
                            setIsResendDisabled(false);  // Enable the button
                            return 0;
                        }
                        return prevCountdown - 1;
                    });
                }, 1000);
            } else {
                toast.error(data.message);
                setLoading(false);
            }
        } catch (error) {
            toast.error("Error While Re-Sending OTP");
            console.log("Error While Re-Sending OTP", error);
            setLoading(false);
        }
    }

    useEffect(() => {
        const isLoggedin = localStorage.getItem("token");
        if (isLoggedin) {
            navigate("/bookmark");
        } else {
            navigate("/login");
        }
    }, [navigate]);

    return (
        <div>
            {
                loading ? <Loading /> :
                    <div className="modal d-block bg-dark bg-opacity-75" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content rounded-4 shadow" style={{
                                backgroundImage: 'url("https://website-app-assets.netlify.app/assets/backgroung-modal-CarRQnwf.jpg")',
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundAttachment: "fixed"
                            }}>
                                <div className="modal-header">
                                    <h5 className="modal-title text-light">Login to Bookmark</h5>
                                    <button
                                        type="button"
                                        className="btn-close bg-light"
                                        onClick={() => {
                                            handleClearComponent();
                                            navigate("/home");
                                        }}
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        if (toggleVerifyOtp === true) {
                                            handleVerifyOtp();
                                        }
                                        else {
                                            handleLogin();
                                        }
                                    }}>
                                    <div className="mb-1 p-2">
                                        <label htmlFor="exampleInputEmail1" className="form-label text-white">Email address:</label>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="form-control"
                                            id="exampleInputEmail1"
                                            disabled={toggleVerifyOtp}
                                            required
                                        />
                                    </div>
                                    <div className="mb-1 p-2">
                                        <div className='d-flex justify-content-between mb-2'>
                                            <label htmlFor="exampleInputPassword1" className="form-label text-white">Password:</label>

                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary text-light p-1 border-0"
                                                onClick={() => {
                                                    handleClearComponent();
                                                    navigate("/forgotPassword");
                                                }}
                                                data-bs-dismiss="modal"
                                            >
                                                Forgot Password
                                            </button>
                                        </div>

                                        <input
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className="form-control"
                                            id="exampleInputPassword1"
                                            disabled={toggleVerifyOtp}
                                            required
                                        />
                                    </div>

                                    {
                                        toggleVerifyOtp &&
                                        <div className="mb-1 p-2">
                                            <div className='d-flex justify-content-between mb-2'>
                                                <label htmlFor="exampleInputOtp1" className="form-label text-white">Enter OTP Here:</label>

                                                <button
                                                    className="btn btn-outline-secondary text-light p-1 border-0"
                                                    type="button"
                                                    onClick={handleResendOtp}
                                                    disabled={isResendDisabled}
                                                >
                                                    {isResendDisabled ? `Wait ${Math.floor(countdown / 60)}:${countdown % 60 < 10 ? '0' : ''}${countdown % 60}` : "Re-Send OTP"}
                                                </button>
                                            </div>
                                            <input
                                                type="text"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                className="form-control"
                                                id="exampleInputOtp1"
                                                required
                                            />
                                        </div>
                                    }

                                    <div className="modal-footer d-flex justify-content-between">
                                        <div className='d-flex gap-2'>
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    handleClearComponent();
                                                    navigate("/signup");
                                                }}
                                                data-bs-dismiss="modal"
                                            >
                                                SignUp Page
                                            </button>
                                        </div>

                                        <div className='d-flex gap-2'>
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    handleClearComponent();
                                                    navigate("/home");
                                                }}
                                                data-bs-dismiss="modal"
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={email.length < 5 || password.length < 6 || (toggleVerifyOtp && otp.length < 6)}
                                            >
                                                {
                                                    toggleVerifyOtp ? "Login" : "Submit"
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
            }

        </div>
    )
}

export default Login
